/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
// import admin from './admin';
// import store from '@/store';
import init from './init';
// import news from './news';

// Array of sections
// export default [...init,...admin,...news];

// let exportData = [...init];
// if (store.state.auth.isAuthenticated) {
//     if (store.state.auth.currentUser.profile.name == 'ADMIN') {
//         exportData = exportData.concat([...admin]);
//     }
// }
export default [...init];

